<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidadeId"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competenciaId"
                    @change="handleCompetenciaChange"
                    label="Mês"
                    show-default-option
                    text-field="mes"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competenciaId"
                    disabled
                    label="Ano"
                    show-default-option
                    text-field="ano"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="form.financiamentos.length > 0">
            <rkm-col>
                <rkm-form-group
                    label-for="Financiamento"
                    label="Financiamento"
                >
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change.native="handleFinanciamentosChange($event)"
                    >
                        Todos
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="form.financiamentos"
                        :validations="validations.financiamentos"
                        name="Financiamento"
                        stacked
                        text-field="nome"
                        v-model="model.financiamentos"
                        value-field="id"
                    />
                </rkm-form-group>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Enums.
import mesesAno from '@/enums/geral/mesesAno'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        indeterminate() {
            return this.model.financiamentos.length > 0 && this.form.financiamentos.length !== this.model.financiamentos.length
        },
        validations() {
            return {
                unidadeId: { required: true },
                competenciaId: { required: true },
                financiamentos: { required: true },
            }
        },
    },
    created() {
        this.repositories.exportacao = this.getConectaSusRepository('bpa.exportacao')
        this.repositories.financiamento = this.getConectaSusRepository('sigtap.financiamento')
    },
    data: () => ({
        enums: {mesesAno},
        form: null,
        model: null,
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.exportacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.form.competencias = this.form.competencias.map(c => {
                        return {
                            id: c.id,
                            mes: this.enums.mesesAno[parseInt(c.valor.slice(4))],
                            ano: c.valor.slice(0,4)
                        }
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCompetenciaChange(id) {
            this.setLoading()

            const request = { competenciaId: id }

            this.repositories.financiamento.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.financiamentos = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleFinanciamentosChange(event) {
            if (event.target.checked === true) {
                this.model.financiamentos = this.form.financiamentos.map(financiamento => financiamento.id)
            } else {
                this.model.financiamentos = []
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        this.repositories.exportacao.store(this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                if (response.data.inconsistencias > 0) {
                                    this.showWarningNotification(`
                                        Arquivo gerado com sucesso:
                                        <ul>
                                            <li>Registros consistentes: <strong>${response.data.consistencias}</strong></li>
                                            <li>Registros inconsistentes: <strong>${response.data.inconsistencias}</strong></li>
                                        </ul>
                                    `)
                                } else {
                                    this.showSaveNotification(`
                                        Arquivo gerado com sucesso:
                                        <ul>
                                            <li>Registros consistentes: <strong>${response.data.consistencias}</strong></li>
                                        </ul>
                                    `)
                                }

                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>